import { TypographyName } from '../../../theme';
import { Text } from '../../display/Text';
import { Link } from '../../navigation/Link';
import { type ColorName } from '../../../theme';

import styles from './SubscriptionForm.module.scss';

type DisclaimerProps = {
  color: 'primary' | 'secondary';
  termsLink?: string;
  privacyLink?: string;
  textType?: TypographyName;
};

/**
 * Internal component for disclaimer which is to be displayed along with Subscription
 * form in page builder
 */
export const DisclaimerText = ({
  color = 'primary',
  termsLink = 'https://zapier.com/tos',
  textType = 'Body1',
  privacyLink = 'https://zapier.com/privacy',
}: DisclaimerProps) => {
  const textColor: ColorName = color === 'primary' ? 'GrayWarm9' : 'PrimeWhite';

  return (
    <div className={styles.ctaDisclaimer} data-zds>
      <Text tag="p" type={textType} color={textColor}>
        By signing up, you agree to Zapier’s{' '}
        <Link href={termsLink} color={color}>
          Terms of Service
        </Link>{' '}
        and{' '}
        <Link href={privacyLink} color={color}>
          Privacy Policy
        </Link>
        .
      </Text>
    </div>
  );
};
